import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'src/@/components/ui/tabs';
import IdentificacaoSection from './ecommerce/IdentificacaoSection';
import CatalogoBuscaSection from './ecommerce/CatalogoBuscaSection';
import PoliticasSection from './ecommerce/PoliticasSection';
import TomConversaSection from './ecommerce/TomConversaSection';
import TransferenciaSection from './ecommerce/TransferenciaSection';
import PerguntasEssenciaisSection from './ecommerce/PerguntasEssenciaisSection';
import InstrucoesAdicionaisSection from './ecommerce/InstrucoesAdicionaisSection';

/**
 * Configuração do vertical de varejo / e-commerce.
 *
 * Espelha a navegação do RealstateModuleConfig (Tabs verticais, sidebar de
 * 240px). Tudo é gravado sob `config.module.ecommerce.*` — a chave do módulo é
 * `ecommerce` nos dois lados, então aqui NÃO existe o problema de grafia que o
 * imobiliário tem (`realestate` no Select vs `realstate` no config, resolvido
 * pelo normalizeModuleKey em AgenteAiDetails.js).
 *
 * As abas Escopo, Venda & Atacado, Funções e Integração CRM entram junto com as
 * funcionalidades que as consomem.
 */
export default function EcommerceModuleConfig({ aiAgent, changeModuleConfig, changeTomConversa, changePersona }) {
    const { t } = useTranslation('settings');

    // Dentro do corpo porque depende de `t` — mesmo motivo do SUB_TABS do realstate.
    const SUB_TABS = [
        { value: 'identificacao', label: t('aiAgents.ecommerce.moduleConfig.tabIdentificacao', 'Identificação'), icon: 'mdi:storefront-outline' },
        { value: 'catalogo-busca', label: t('aiAgents.ecommerce.moduleConfig.tabCatalogoBusca', 'Catálogo & Busca'), icon: 'mdi:magnify' },
        { value: 'politicas', label: t('aiAgents.ecommerce.moduleConfig.tabPoliticas', 'Políticas Comerciais'), icon: 'mdi:file-document-outline' },
        { value: 'tom-conversa', label: t('aiAgents.ecommerce.moduleConfig.tabTomConversa', 'Tom da Conversa'), icon: 'mdi:chat-processing-outline' },
        { value: 'transferencia', label: t('aiAgents.ecommerce.moduleConfig.tabTransferencia', 'Transferência'), icon: 'mdi:account-arrow-right-outline' },
        { value: 'perguntas-essenciais', label: t('aiAgents.ecommerce.moduleConfig.tabPerguntasEssenciais', 'Perguntas Essenciais'), icon: 'mdi:comment-question-outline' },
        { value: 'instrucoes-adicionais', label: t('aiAgents.ecommerce.moduleConfig.tabInstrucoesAdicionais', 'Instruções Adicionais'), icon: 'mdi:format-quote-close' },
    ];

    return (
        <Tabs defaultValue="identificacao" orientation="vertical" className="flex gap-6 items-start">
            <TabsList className="flex flex-col items-stretch h-auto w-[240px] bg-white rounded-xl border border-gray-100 p-2 gap-1 shrink-0">
                {SUB_TABS.map((tab) => (
                    <TabsTrigger
                        key={tab.value}
                        value={tab.value}
                        className="justify-start gap-2 px-3 py-2.5 rounded-lg text-sm text-gray-600 hover:bg-gray-50 data-[state=active]:bg-violet-50 data-[state=active]:text-[#7C3AED] data-[state=active]:shadow-none data-[state=active]:font-semibold w-full"
                    >
                        <Iconify icon={tab.icon} width={16} />
                        <span className="text-left flex-1 truncate">{tab.label}</span>
                    </TabsTrigger>
                ))}
            </TabsList>

            <div className="flex-1 min-w-0">
                <TabsContent value="identificacao" className="mt-0">
                    <IdentificacaoSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} changePersona={changePersona} />
                </TabsContent>
                <TabsContent value="catalogo-busca" className="mt-0">
                    <CatalogoBuscaSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="politicas" className="mt-0">
                    <PoliticasSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="tom-conversa" className="mt-0">
                    <TomConversaSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} changeTomConversa={changeTomConversa} />
                </TabsContent>
                <TabsContent value="transferencia" className="mt-0">
                    <TransferenciaSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="perguntas-essenciais" className="mt-0">
                    <PerguntasEssenciaisSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
                <TabsContent value="instrucoes-adicionais" className="mt-0">
                    <InstrucoesAdicionaisSection aiAgent={aiAgent} changeModuleConfig={changeModuleConfig} />
                </TabsContent>
            </div>
        </Tabs>
    );
}
